import { render } from "./HotelPage.vue?vue&type=template&id=6e909d1e"
import script from "./HotelPage.vue?vue&type=script&lang=js"
export * from "./HotelPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__